import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  DocumentFeedbackSuccess,
  DocumentFeedbackWarning,
  DocumentFeedbackOverdue
} from '@plataforma/components';

import * as S from './DocumentStatusStyles';

function renderIcon(status) {
  switch (status) {
    case 'policyIssued':
      return <DocumentFeedbackSuccess />;
    case 'renew':
      return <DocumentFeedbackWarning />;
    case 'canceled':
      return <DocumentFeedbackOverdue />;
    default:
      return null;
  }
}

function DocumentStatus({ status }) {
  const { t } = useTranslation();
  return (
    status && (
      <S.Wrapper status={status}>
        {renderIcon(status)}
        <S.Title>{t(`status.${status}`)}</S.Title>
      </S.Wrapper>
    )
  );
}

DocumentStatus.propTypes = {
  status: PropTypes.string.isRequired
};

export default DocumentStatus;
